define('app/views/buy_button_view',['app/setup'], function(takhfifan) {

  takhfifan.BuyButtonView = Backbone.View.extend({

    events: {
      'click': 'submit'
    },

    initialize: function(options) {
      var _this = this;
      this.btnText=this.$('.btn-text').html();
      this.productId = options.productId;
      takhfifan.eventHub.on('timeover:' + this.productId, function() {
        _this.disable();
        _this.setAsDeactive();
      }, this);
      takhfifan.eventHub.on('buyButton:soldOut', function() {
        _this.disable();
        _this.setAsDeactive();
      }, this);

      takhfifan.eventHub.on('groupedProduct:removeAssociate', function(opts) {
        if(_this.productId===opts.productId) {
          _this.disable();
          _this.setAsDeactive();
        }
      }, this);
      if(this.$el.attr('disabled') !== 'disabled'){
        takhfifan.eventHub.on('buyButton:enable', function() {
          _this.enableButton();
        }, this);
        takhfifan.eventHub.on('cartinfo:' + this.productId, function(){
          this.setAsActive();
        }, this);
      }
    },

    enableButton: function() {
      this.setAsActive();
      this.enable();
    },

    submit: function(event) {
      var _this = this;
      event.preventDefault();
      if(!_this.$el.hasClass('tkh-configurable-buy-btn') &&
        !_this.$el.hasClass('tkh-configurable-options')&&
        !_this.$el.hasClass('tkh-offline-hotel-buy-btn')) {
          takhfifan.eventHub.trigger('productaddtocart:' + this.productId, this);
          this.setAsLoading();
          this.disable();
      }
      else if (_this.$el.hasClass('tkh-offline-hotel-buy-btn')) {
        takhfifan.eventHub.trigger('hotelOffline:showRequestForm');
      }
      else {
        this.setAsLoading();
        this.disable();
        takhfifan.eventHub.trigger('configurableProduct:addToCartCheck', this);
      }
      return false;
    },

    setAsLoading: function() {
      this.$('.btn-text').empty().append('<span class="spinner"></span>');
      this.$el.addClass('disabled-btn');
    },

    setAsActive: function() {
      if (this.$el.hasClass('tkh-offline-hotel-buy-btn')) {
        this.$('.btn-text').empty().append('درخواست رزرو');
      } else {
        this.$('.btn-text').empty().append('<span class="icon-cart"></span>همین حالا خرید کنید');
      }
      this.$el.removeClass('disabled-btn');
    },
    
    setAsDeactive: function() {
      this.$('.btn-text').empty().append('<span class="icon-cart"></span>این تخفیفان به پایان رسید');
    },

    disable: function() {
      this.undelegateEvents();
      this.$el.attr('disabled', true);
    },

    enable: function() {
      this.delegateEvents();
      this.$el.attr('disabled', false);
    }

  });

});

